import { render, staticRenderFns } from "./ProductsTableV2.vue?vue&type=template&id=0b51a84c&"
import script from "./ProductsTableV2.vue?vue&type=script&lang=js&"
export * from "./ProductsTableV2.vue?vue&type=script&lang=js&"
import style0 from "./ProductsTableV2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports